export default {
  UPDATE_BYPASS_PAYWALL: "[bypassPaywall] Update Bypass Paywall",
  RESET_BYPASS_PAYWALL: "[bypassPaywall] Reset Bypass Paywall",
};
